// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getValueByPath = (obj: any, path: string): any =>
  path.split(".").reduce((current, key) => {
    if (current === null || current === undefined) {
      return undefined;
    }

    // Handle array indices
    if (!isNaN(Number(key))) {
      return current[Number(key)];
    }

    return current[key];
  }, obj);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setValueByPath = (obj: any, path: string, value: any): void => {
  const keys = path.split(".");
  const lastKey = keys.pop()!;

  const target = keys.reduce((current, key) => {
    if (current === null || current === undefined) {
      return {};
    }

    if (!isNaN(Number(key))) {
      if (!Array.isArray(current)) {
        return {};
      }
      if (!current[Number(key)]) {
        current[Number(key)] = {};
      }
      return current[Number(key)];
    }

    if (!current[key]) {
      current[key] = {};
    }
    return current[key];
  }, obj);

  if (target && typeof target === "object") {
    if (!isNaN(Number(lastKey)) && Array.isArray(target)) {
      target[Number(lastKey)] = value;
    } else {
      target[lastKey] = value;
    }
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasValueAtPath = (obj: any, path: string): boolean => {
  const value = getValueByPath(obj, path);
  return value !== undefined && value !== null;
};

export const getPathDisplayName = (path: string): string => {
  const parts = path.split(".");
  const lastPart = parts[parts.length - 1];

  // Convert camelCase to readable format
  return lastPart
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, str => str.toUpperCase())
    .trim();
};

export const isPathEqual = (path1: string, path2: string): boolean => path1 === path2;

export const isPathParent = (parentPath: string, childPath: string): boolean =>
  childPath.startsWith(parentPath + ".");

export const getParentPath = (path: string): string | null => {
  const lastDotIndex = path.lastIndexOf(".");
  return lastDotIndex === -1 ? null : path.substring(0, lastDotIndex);
};
